import EditAction from "assets/svgs/edit_action";
import React, { useState } from "react";
import { Button, CloseButton, Form, Modal } from "react-bootstrap";
import { useEditBreak } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import {OverlayTrigger} from "react-bootstrap";
import {Tooltip} from "react-bootstrap";

function BreakDayModal({ breakDays, id }) {
  const { setToaster } = useToast();
  const { editBreakDays } = useEditBreak();
  const [modalShow, setModalShow] = useState(false);
  const [selectedDays, setSelectedDays] = useState(breakDays);

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const handleCheckboxChange = (index) => {
    if (selectedDays.includes(index)) {
      setSelectedDays(selectedDays.filter((day) => day !== index));
    } else {
      setSelectedDays([...selectedDays, index]);
    }
  };

  return (
    <>
      <div onClick={() => setModalShow(true)}>
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
              <span className="fw-bold">Break Day</span>
            </Tooltip>
          }
        >
          <span className="cursor-pointer">
            {" "}
            <EditAction />
          </span>
        </OverlayTrigger>
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Break Day
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <Form className="text-center">
            {days.map((day, index) => (
              <Form.Check
                key={index}
                inline
                type="checkbox"
                id={day}
                label={day}
                checked={selectedDays.includes(index)}
                onChange={() => handleCheckboxChange(index)}
              />
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setModalShow(false);
              editBreakDays(id, selectedDays, setToaster);
            }}
          >
            save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BreakDayModal;
